var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-badge",class:`status-badge--${_vm.active ? 'active' : 'inactive'}`},[_c('a-icon',{attrs:{"type":_vm.active ? 'check-circle' : 'minus-circle',"theme":"filled"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }